import { URLS_TO_IGNORE_ADDITION_HEADERS } from '../../config/interceptor.ts';
import type { BuildHeadersProps, HeadersParams } from '../http-client.types.ts';
import { buildAuthHeader } from './auth.functions.ts';

export function shouldAddExtraHeaders(url: string): boolean {
  return !URLS_TO_IGNORE_ADDITION_HEADERS.some(urlToIgnore =>
    typeof urlToIgnore === 'string' ? url.includes(urlToIgnore) : urlToIgnore.test(url)
  );
}

export function buildHeaders({ url, token, currentLanguage, companyId, baseHeaders }: BuildHeadersProps): HeadersParams {
  const extraHeaders = shouldAddExtraHeaders(url)
    ? {
        'Accept-Language': currentLanguage,
        ...(companyId ? { 'X-Company-Id': companyId } : {})
      }
    : {};

  return {
    ...baseHeaders,
    ...extraHeaders,
    Authorization: buildAuthHeader(url, token)
  };
}
